// extracted by mini-css-extract-plugin
export default {"card":"darkStoereList_card__wCOaj","block":"darkStoereList_block__zf6JS","list":"darkStoereList_list__E33yk","content":"darkStoereList_content__lPy5q"};